<template>
  <section class="container-fluid bg-white">
    <Table
      :data="this.groups || []"
      :columns="table.columns"
      :actionButton="table.actionButton"
      :disableSearch="false"
      :search="table.search"
      :actions="table.actions"
      @rowClicked="table.clickHandler"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'listGroups',
  data () {
    return {
      table: {
        columns: [
          {
            label: 'Title',
            property: 'title',
            searchable: true,
            sort: { enabled: true, default: true }
          },
          {
            label: 'Name',
            property: 'name',
            searchable: true,
            sort: { enabled: true }
          }
        ],
        actions: [
          { icon: 'fas fa-external-link-square-alt', action: this.openInNewTab },
          { icon: 'fas fa-trash-alt', buttonClass: 'btn-danger', action: this.deleteItem }
        ],
        actionButton: {
          icon: 'fa fa-plus',
          label: 'Create new group',
          action: () => this.$router.push({ name: 'GroupCreate', params: { client: this.$route.params.client } })
        },
        clickHandler: this.editGroup,
        search: {
          placeholder: 'Search groups',
          disabled: false
        }
      },
      dcrFrontendHost: import.meta.env.VITE_DCR_FRONTEND_HOST
        .replace('http://', '')
        .replace('https://', '')
    }
  },
  computed: {
    ...mapGetters({
      groups: 'getGroupsList'
    }),
    isLoading: {
      get () {
        return this.$store.getters.getLoadingState
      },
      set (val) {
        this.$store.commit('SET_LOADING_STATE', val)
      }
    },
    isLocalHost () {
      return this.dcrFrontendHost.includes('localhost')
    }
  },
  created () {
    this.$store.commit('SET_GROUPS_LIST', false)
    this.getGroups()
  },
  methods: {
    openInNewTab (item) {
      const targetUrl = `${this.isLocalHost ? 'http' : 'https'}://${this.$route.params.client}.${this.dcrFrontendHost}/groups/${item.name}`
      window.open(targetUrl, '_blank')
    },
    editGroup (item) {
      this.$router.push('/clients/' + this.$route.params.client + '/groups/' + item.id)
    },
    getGroups () {
      if (!this.groups) {
        this.isLoading = true
        this.$store
          .dispatch('getGroupsList', this.$route.params.client)
          .then(response => {
            this.isLoading = false
          }).catch(error => {
            this.isLoading = false
            this.error = true
            this.$swal({
              title: 'Error',
              text: error,
              icon: 'error'
            })
          })
      }
    },
    deleteItem (item) {
      this
        .$swal({
          title: 'Are you really sure?',
          text: 'The group "' + item.name + '" will be deleted. This cannot be undone!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#dd4b39',
          cancelButtonText: 'Cancel'
        })
        .then(
          result => {
            if (result.value) {
              this.isLoading = true
              const data = {
                client: this.$route.params.client,
                item: item
              }
              this.$store
                .dispatch('deleteGroup', data)
                .then(response => {
                  this.groups.splice(this.groups.indexOf(item), 1)
                  this.$swal({
                    title: 'Success',
                    text: 'Group "' + item.name + '" has been deleted',
                    icon: 'success',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top',
                    timer: 2000
                  })
                  this.isLoading = false
                }).catch(error => {
                  this.isLoading = false
                  this.error = true
                  this.$swal({
                    title: 'Error',
                    text: error,
                    icon: 'error'
                  })
                })
            }
          }
        )
    }
  }
}
</script>
